import { useEffect, useRef, useState, Fragment } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import ReactPaginate from "react-paginate";
import { useForm, Controller } from "react-hook-form";
import Button from "../../components/Button";
import Card from "../../components/Card";
import ContentList from "../../components/ContentList";
import Loader from "../../components/Loader";
import Modal from "../../components/Modal";
import Dropzone from "../../components/Dropzone";
import BigLoader from "../../components/BigLoader";
import { setInterface } from "../../redux/slices/interfaceSlice";
import service from "../../service";

export default function DeepRead() {
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const mountedRef = useRef(true);
  const [selectedId, setSelectedId] = useState(null);
  const [postLoading, setPostLoading] = useState(false);
  const _modalCover = useRef();
  const {
    control,
    handleSubmit,
    watch,
    reset,
  } = useForm();

  const getData = (currentPage) => {
    setLoading(true);
    service
      .get("/api/deep-read", { params: { page: currentPage } })
      .then((response) => {
        if (!mountedRef.current) return;
        const { total, data } = response.data;
        setTotal(total);
        setData(data);
        setLoading(false);
      })
      .catch(() => {
        if (!mountedRef.current) return;
        setLoading(false);
      });
  };

  useEffect(() => {
    dispatch(
      setInterface({
        active: "Deep Read",
        pageTitle: "Deep Read",
        rightButton: {
          to: "/deep-read/add",
          label: "Tambah",
          color: "green",
          withPlusIcon: true,
        },
      })
    );
    return () => {
      mountedRef.current = false;
    };
  }, [dispatch]);

  useEffect(() => {
    getData(page);
  }, [page]);

  const changeCover = ({ cover }) => {
    if (!selectedId || !cover) return;
    setPostLoading(true);
    const formData = new FormData();
    formData.append("cover", cover);
    service
      .put(`/api/deep-read/${selectedId}`, formData)
      .then(() => {
        setPostLoading(false);
        _modalCover.current.hide();
        reset({ cover: null });
        getData(page);
      })
      .catch(() => {
        setPostLoading(false);
      });
  };

  return (
    <Card>
      <Helmet>
        <title>Deep Read</title>
      </Helmet>
      <div className="mb-6" />
      {loading ? (
        <div className="h-64 flex justify-center items-center flex-col">
          <Loader className="bg-black-100" />
          <span className="mt-3 text-black-300 text-sm">Memuat</span>
        </div>
      ) : data.length ? (
        <Fragment>
          {data.map((item) => (
            <ContentList
              imgSrc={item.cover}
              title={item.title}
              babs={item.books_count}
              countDisplay={`${item.books_count || 0} Books`}
              countLabel="Buku"
              showCreatedTime={false}
              manageLabel="Kelola Buku"
              key={item.id}
              createdTime={item.created_at}
              id={item.id}
              detailLink={`/deep-read/${item.id}/book`}
              editLink={`/deep-read/edit/${item.id}`}
              onChangeCover={(id) => {
                setSelectedId(id);
                reset({ cover: null });
                _modalCover.current.show();
              }}
            />
          ))}

          <ReactPaginate
            pageCount={total}
            pageRangeDisplayed={5}
            marginPagesDisplayed={1}
            initialPage={page - 1}
            containerClassName="flex flex-wrap mt-6 gap-1"
            previousLinkClassName="border border-white-300 rounded-sm py-1.5 px-3 text-sm transition-colors hover:bg-primary-500 hover:border-primary-600 hover:text-white-100 block"
            nextLinkClassName="border border-white-300 rounded-sm py-1.5 px-3 text-sm transition-colors hover:bg-primary-500 hover:border-primary-600 hover:text-white-100 block"
            pageLinkClassName="border border-white-300 rounded-sm py-1.5 px-3 text-sm transition-colors hover:bg-primary-500 hover:border-primary-600 hover:text-white-100 block"
            activeLinkClassName="bg-primary-500 border-primary-600 text-white-100"
            onPageChange={({ selected }) => setPage(selected + 1)}
          />
        </Fragment>
      ) : (
        <div className="text-center flex flex-col justify-center items-center h-40 text-black-300">
          <p>Belum ada Deep Read. Klik Tambah untuk membuat baru.</p>
        </div>
      )}
      <Modal title="Ganti Cover" ref={_modalCover}>
        <form onSubmit={handleSubmit(changeCover)}>
          <Controller
            name="cover"
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange } }) => (
              <Dropzone
                containerClassName="mb-4"
                onChange={(accepted) => {
                  onChange(accepted[0]);
                }}
                dropzone={{ accept: "image/jpeg, image/png" }}
              />
            )}
          />
          {watch("cover") ? (
            <Fragment>
              <span className="text-sm font-semibold text-black-300 mb-2 block">Preview</span>
              <div className="flex justify-center mb-4">
                <img
                  src={URL.createObjectURL(watch("cover"))}
                  alt="Preview Cover"
                  className="w-28 h-28 object-cover"
                />
              </div>
            </Fragment>
          ) : null}
          <Button type="submit" color="blue" className="w-28">
            Simpan
          </Button>
        </form>
      </Modal>
      {postLoading ? <BigLoader /> : null}
    </Card>
  );
}
